import React, { useRef, useState,useEffect, useContext } from 'react';
import styles from '../styles.module.css';
import SyntaxHighlighter from 'react-syntax-highlighter';
import {FaPlay,FaPause, FaArrowAltCircleLeft} from 'react-icons/fa';
import { data as LineData } from '../../LineCharts/LineChart/data';
import { data as AreaData } from '../../LineCharts/AreaChart/data';
import { AppContext } from '../../../AppContext';

const animatedCode=`import { LineChart } from "react-native-gifted-charts"
const App = () => {
const lineData = [
    {value: 0, dataPointText: '0'},
    {value: 20, dataPointText: '20'},
    {value: 18, dataPointText: '18'},
    {value: 40, dataPointText: '40'},
    {value: 36, dataPointText: '36'},
    {value: 60, dataPointText: '60'},
    {value: 54, dataPointText: '54'},
    {value: 85, dataPointText: '85'}
];
return (
    <View style={{backgroundColor: '#1A3461'}}>
        <LineChart
            initialSpacing={0}
            data={lineData}
            isAnimated
            spacing={30}
            textColor1="yellow"
            textShiftY={-8}
            textShiftX={-10}
            textFontSize={13}
            thickness={5}
            hideRules
            hideYAxisText
            yAxisColor="#0BA5A4"
            showVerticalLines
            verticalLinesColor="rgba(14,164,164,0.5)"
            xAxisColor="#0BA5A4"
            color="#0BA5A4"
        />
    </View>
);
};`
const lineStyle={marginLeft:-20,fontSize:16,color:'gray'}
const LineChartGallery=props=>{
    const appContext = useContext(AppContext);
    const{isMobile} = appContext;
    const [isPlaying,setIsplaying]=useState(false)
    const [isPlaying2,setIsplaying2]=useState(false)
    const [isPlaying3,setIsplaying3]=useState(false)
    const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth);
    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    }
  },[])
  
  const updateWindowWidth = () => {
    setWidth(window.innerWidth)
  }
    const videoRef=useRef();
    const onplayClick=()=>{
        if(isPlaying){
            videoRef.current.pause();
            setIsplaying(false)
        }
        else{
            videoRef.current.play();
            setIsplaying(true)
        }
    }
    const onVideoEnd=()=>{
        setIsplaying(false)
    }

    const videoRef2=useRef();
    const onplayClick2=()=>{
        if(isPlaying2){
            videoRef2.current.pause();
            setIsplaying2(false)
        }
        else{
            videoRef2.current.play();
            setIsplaying2(true)
        }
    }

    const onVideoEnd2=()=>{
        setIsplaying2(false)
    }

    const videoRef3=useRef();
    const onplayClick3=()=>{
        if(isPlaying3){
            videoRef3.current.pause();
            setIsplaying3(false)
        }
        else{
            videoRef3.current.play();
            setIsplaying3(true)
        }
    }

    const onVideoEnd3=()=>{
        setIsplaying3(false)
    }
    return(
        <div className={styles.container}>
            <FaArrowAltCircleLeft
            onClick={()=>{window.location.pathname="/gallery"}}
            style={{fontSize:30,position:'absolute',cursor:'pointer',top:isMobile?70:110}}/>
            <h2>
                Line Chart Examples
                <a style={{marginLeft:20,fontSize:15}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/LineChart/LineChartProps.md' rel="noreferrer">
                    props table
                </a> 
            </h2>
            <div style={{marginLeft:10,marginBottom:100}}>
                <div className={styles.boxStyle}>
                    <img
                    src={require('../../../assets/lineLabelled.png')}
                    className={styles.barOutput}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {LineData[3].code}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <video
                    ref={videoRef}
                    muted
                    autoPlay
                    onEnded={onVideoEnd}
                    className={styles.outputBig}
                    src={require('../../../assets/lining.mov')}/>

                    <p style={{fontSize:24}}>
                        {isPlaying?
                        <FaPause onClick={onplayClick}/>:
                        <FaPlay onClick={onplayClick}/>}
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {animatedCode}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <img
                    src={LineData[4].imgSrc}
                    className={styles.outputBig}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {LineData[4].code}
                    </SyntaxHighlighter>
                </div>
            </div>

            <hr/>

            <h2>
                Area Chart Examples
                <a style={{marginLeft:20,fontSize:15}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/LineChart/LineChartProps.md' rel="noreferrer">
                    props table
                </a> 
            </h2>
            <div style={{marginLeft:10,marginBottom:40}}>
                <div className={styles.boxStyle}>
                    <img
                    src={AreaData[2].imgSrc}
                    className={styles.outputBig}
                    alt=''/>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {AreaData[2].code}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <video
                    ref={videoRef2}
                    muted
                    autoPlay
                    onEnded={onVideoEnd2}
                    className={styles.outputBig}
                    src={require('../../../assets/areaanim.mov')}/>

                    <p style={{fontSize:24}}>
                        {isPlaying2?
                        <FaPause onClick={onplayClick2}/>:
                        <FaPlay onClick={onplayClick2}/>}
                    </p>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                    {AreaData[3].code}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <img
                    src={AreaData[4].imgSrc}
                    className={styles.outputBig}
                    alt=''/>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {AreaData[4].code}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                    src={AreaData[5].imgSrc}
                    className={styles.outputBig}
                    alt=''/>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {AreaData[5].code}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                <video
                    ref={videoRef3}
                    muted
                    autoPlay
                    onEnded={onVideoEnd3}
                    className={styles.outputBig}
                    src={require('../../../assets/pointerConfig.mp4')}/>

                    <p style={{fontSize:24}}>
                        {isPlaying3?
                        <FaPause onClick={onplayClick3}/>:
                        <FaPlay onClick={onplayClick3}/>}
                    </p>

                    <p>
                        The code for the above chart is-
                    </p>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                    {AreaData[6].code}
                    </SyntaxHighlighter>
                    
                </div>
                <div className={styles.boxStyle}>
                <img
                        src='https://user-images.githubusercontent.com/20596944/166833722-00d8213f-3d7d-422b-840d-c5fe92b3bfb9.gif'
                        style={{height:280}}
                        alt=''/>
                        <p>
                            The code for the above chart is-
                        </p>
                        <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {AreaData[7].code}
                        </SyntaxHighlighter>
                </div>
            </div>
        </div>
    );
}

export default LineChartGallery;